import { render, staticRenderFns } from "./tuYaPage.vue?vue&type=template&id=a98e07f8&"
import script from "./tuYaPage.vue?vue&type=script&lang=js&"
export * from "./tuYaPage.vue?vue&type=script&lang=js&"
import style0 from "./tuYaPage.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports